import script from "./GroupRegistrationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupRegistrationForm.vue?vue&type=script&setup=true&lang=ts"

import "./GroupRegistrationForm.vue?vue&type=style&index=0&id=17050f1e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17050f1e"]])

export default __exports__